// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"280bb520","422":"ef195a04","667":"1becb5d6","977":"c5b004b5"}[chunkId] + ".chunk.js";
};